module.exports = __webpack_public_path__ + "media/images/carousel/banner_2-b5a95cb2cf486e777ed94f91660721aa.jpg";